module.exports = __webpack_public_path__ + "static/media/corporateStep7.81446de2.svg";